import { faPaperPlane, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import Moment from "react-moment";
import "moment/locale/es-mx"
import { Card, Button, Form, Row, Col, Modal } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import Axios from "axios";

class Mensajes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mensajes: [],
            respuestas: [],
            modalNuevoMensaje: false,
            ambitosSelect: null,
            anexosSelect: null,
            tituloMensaje: "",
            mensajeMensaje: "",
            ambito: -1,
            anexo: -1,
            formatos: [],
            ambaitos: [],
            muestraSelects: false
        };
    }

    componentDidMount = () => {
        let muestraSelects = false
        if (this.props.ambito_id == -1 || this.props.ambito_id == 0) {
            muestraSelects = true
        }
        this.cargaMensajes()
        Axios({
            method: "get",
            url:
                "http://143.198.191.211/api/Ambito?api_token=" +
                localStorage.api_token,
            data: {},
        }).then((res) => {
            let ambitosSelect = []
            ambitosSelect.push(
                <option key={-1} value={-1} disabled selected>
                    Seleccione una opción...
                </option>
            )
            if (this.props.ambito_id == -1) {
                ambitosSelect.push(
                    <option key={0} value={0}>
                        Todos los ámbitos
                    </option>
                )
            }
            if (this.props.ambito_id == -1) {
                res.data
                    .filter((ambi) => {
                        return localStorage.ambitos
                            .split(",")
                            .map(Number);
                    })
                    .map((ambito) => (
                        ambitosSelect.push(
                            <option key={ambito.id} value={ambito.id}>
                                {ambito.id + ".- " + this.creaAmbitoTexto(ambito)}
                            </option>
                        )
                    ))
            } else {
                res.data
                    .filter((ambi) => {
                        return localStorage.ambitos
                            .split(",")
                            .map(Number)
                            .includes(ambi.id);
                    })
                    .map((ambito) => (
                        ambitosSelect.push(
                            <option key={ambito.id} value={ambito.id}>
                                {ambito.id + ".- " + this.creaAmbitoTexto(ambito)}
                            </option>
                        )
                    ))
            }


            this.setState({
                ambitosSelect: ambitosSelect,
                anexosSelect: <option key={-1} value={-1} disabled selected>Seleccione una opción...</option>,
                ambaitos: res.data,
                ambito: -1,
                anexo: -1,
                muestraSelects: muestraSelects
            });
        });

        Axios({
            method: "get",
            url:
                "http://143.198.191.211/api/anexoClaveNombre?api_token=" +
                localStorage.api_token,
            data: {},
        }).then((res) => {
            this.setState({ formatos: res.data });
        });

        setInterval(() => this.cargaMensajes(), 60000)
    };

    creaAmbitoTexto = (ambito) => {
        let texto = ambito.ente
        if (ambito.dirgral) {
            texto = texto + " / " + ambito.dirgral
        }
        if (ambito.dir) {
            texto = texto + " / " + ambito.dir
        }
        if (ambito.depto) {
            texto = texto + " / " + ambito.depto
        }
        return texto
    }

    onChangeMensajeMensaje = e => {
        this.setState({ mensajeMensaje: e.target.value });
    }

    onChangeTituloMensaje = e => {
        this.setState({ tituloMensaje: e.target.value });
    }

    onChangeAmbito = (etxt) => {
        let anexosSelect = []
        let id = parseInt(etxt)
        const encontrado = this.state.ambaitos.find(amb => amb.id === id)
        anexosSelect.push(
            <option key={-1} value={-1} disabled selected>Seleccione una opción...</option>
        )
        anexosSelect.push(
            <option key={0} value={0}>
                Escritorio
            </option>
        )
        if (this.props.ambito_id == -1) {
            let formatos = this.state.formatos
            for (const element in formatos) {
                anexosSelect.push(
                    <option key={element} value={element}>
                        {element + ".- " + formatos[element]}
                    </option>
                )
            }
        } else {
            if (encontrado) {
                let estosFormatos = encontrado.formatos.split(",")
                estosFormatos.forEach(element => {
                    if (element) {
                        anexosSelect.push(
                            <option key={element} value={element}>
                                {element + ".- " + this.state.formatos[element]}
                            </option>
                        )
                    }
                });
            }
        }
        this.setState({ ambito: id, anexosSelect: anexosSelect, anexo: -1 })
    }

    onChangeAnexo = e => {
        this.setState({ anexo: e.target.value })
    }

    showModalNuevoMensaje = () => {
        this.setState({ modalNuevoMensaje: true });
    };

    hideModalNuevoMensaje = () => {
        this.setState({ modalNuevoMensaje: false });
    };

    ReverseObject = (Obj) => {
        var TempArr = [];
        var NewObj = [];
        for (var Key in Obj) {
            TempArr.push(Key);
        }
        for (var i = TempArr.length - 1; i >= 0; i--) {
            NewObj[TempArr[i]] = Obj[TempArr[TempArr.length - 1 - i]];
        }
        return NewObj;
    }

    cargaMensajes = () => {
        let mensajes = []
        let getAmbito = this.props.ambito_id
        if (getAmbito == 0) {
            getAmbito = localStorage.ambitos
        }
        Axios({
            method: "get",
            url:
                "http://143.198.191.211/api/Mensaje/ambito/" +
                getAmbito +
                "/anexo_clave/" +
                this.props.formato +
                "?api_token=" +
                localStorage.api_token,
            data: {},
        }).then((res) => {
            mensajes = res.data
            this.props.totalMensajes(mensajes.length)
            this.setState({ mensajes: mensajes })
        });
    };

    onChangeRespuesta = (i, m) => {
        let respuestas = [...this.state.respuestas]
        respuestas[i] = m
        this.setState({ respuestas: respuestas })
    };

    guardaComentario = (ele, e) => {
        let data = {
            //Recoger la información para el registro
            es_respuesta: true,
            msjOg: ele,
            msj: this.state.respuestas[ele.id].trim(),
            nombre_usuario: localStorage.nombrecompleto,
            usuario_id: localStorage.id,
            api_token: localStorage.api_token,
        };
        let config = {};
        Axios.post("http://143.198.191.211/api/Mensaje", data, config).then((res) => {
            this.cargaMensajes();
            this.onChangeRespuesta(ele.id, "");
        });
    };

    boarraMensaje = (ele, e) => {
        let data = {
            api_token: localStorage.api_token,
        };
        let config = {};
        Axios.delete("http://143.198.191.211/api/Mensaje/" +
            ele.id +
            "?api_token=" +
            localStorage.api_token,
            data,
            config
        ).then((res) => {
            this.cargaMensajes();
        });
    };

    enviaMensaje = () => {
        let elAmbito = this.state.ambito
        let elAnexo = this.state.anexo
        if (this.props.ambito_id && this.props.ambito_id != "-1") {
            elAmbito = this.props.ambito_id
        }
        if (this.props.formato && this.props.formato != "-1") {
            elAnexo = this.props.formato
        }
        let data = {
            //Recoger la información para el registro
            es_respuesta: false,
            usuario_id: localStorage.id,
            nombre_usuario: localStorage.nombrecompleto,
            titulo: this.state.tituloMensaje,
            mensaje: this.state.mensajeMensaje,
            ambito_id: elAmbito,
            anexo_clave: elAnexo,
            api_token: localStorage.api_token,
        };
        let config = {};
        Axios.post("http://143.198.191.211/api/Mensaje", data, config).then((res) => {
            this.cargaMensajes()
            this.hideModalNuevoMensaje()
            this.setState({
                tituloMensaje: "",
                mensajeMensaje: "",
                ambito: -1,
                anexo: -1,
            });
        });
    };

    muestraMensajes = () => {
        let estosMensajes = []
        this.state.mensajes.forEach(ele => {
            if (ele.respuesta_de == null) {
                estosMensajes[ele.id] = ele
            } else {
                if (!estosMensajes[ele.respuesta_de].respuesta) {
                    estosMensajes[ele.respuesta_de]["respuesta"] = []
                }
                estosMensajes[ele.respuesta_de].respuesta[ele.id] = ele
            }
        });

        estosMensajes = this.ReverseObject(estosMensajes)
        return (
            <>
                <div className="mt-5">&nbsp;</div>
                <Col xs={12}>
                    <Button variant="primary" data-tip="Nuevo Mensaje" onClick={() => this.showModalNuevoMensaje()}>
                        <FontAwesomeIcon icon={faPaperPlane} /> Nuevo Mensaje
                    </Button>
                    <br></br>
                    <br></br>
                </Col>
                {estosMensajes.length == 0 &&
                    <Col xs={12}>
                        <br></br>
                        <h3 className="text-muted">Sin Mensajes</h3>
                    </Col>
                }
                {(estosMensajes).map((ele, i) =>
                    <Col key={ele.id} xs={12}>
                        <Card className="card-mensaje">
                            <Card.Header>
                                De <b>{ele.nombre_usuario}</b>
                                <span className="text-right" style={{ float: "right" }}>
                                    <Moment interval={30000} calendar locale="es-mx" className="text-muted">
                                        {ele.fecha_publicado}
                                    </Moment>
                                    {" "}{" "}
                                    {localStorage.id == ele.usuario_id &&
                                        <button
                                            type="button"
                                            data-tip="Borrar Mensaje"
                                            onClick={(e) => this.boarraMensaje(ele, e)}
                                            className="btn btn-outline-danger btn-sm mensajeBorrar"
                                            size="sm">
                                            <FontAwesomeIcon icon={faTrashAlt} />
                                        </button>
                                    }
                                </span>
                                <br></br>
                                {
                                    ele.ambito_id != 0
                                        ? <span>Para <b>ambito {ele.ambito_id}</b></span>
                                        : <span>Para <b>todos los ambitos</b></span>
                                }
                                {
                                    ele.anexo_clave != 0
                                        ? <span> en anexo <b>{ele.anexo_clave}</b></span>
                                        : ""
                                }
                            </Card.Header>
                            <Card.Body>
                                <Card.Title>{ele.titulo}</Card.Title>
                                <Card.Text>
                                    {ele.mensaje}
                                    {ele.respuesta &&
                                        (ele.respuesta).map((eleR, i) =>
                                            <Row key={eleR.id}>
                                                <Col xs={12} style={{ padding: "5px" }}>
                                                    <Card className="card-mensaje-respuesta">
                                                        <Card.Header>
                                                            De <b>{eleR.nombre_usuario}</b>
                                                            <span className="text-right" style={{ float: "right" }}>
                                                                <Moment interval={30000} calendar locale="es-mx" className="text-muted">
                                                                    {eleR.fecha_publicado}
                                                                </Moment>
                                                                {" "}{" "}
                                                                {localStorage.id == eleR.usuario_id &&
                                                                    <button
                                                                        type="button"
                                                                        data-tip="Borrar Mensaje"
                                                                        onClick={(e) => this.boarraMensaje(eleR, e)}
                                                                        className="btn btn-outline-danger btn-sm mensajeBorrar"
                                                                        size="sm">
                                                                        <FontAwesomeIcon icon={faTrashAlt} />
                                                                    </button>
                                                                }
                                                            </span>
                                                        </Card.Header>
                                                        <Card.Body>
                                                            <Card.Text>
                                                                {eleR.mensaje}
                                                            </Card.Text>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        )}
                                </Card.Text>
                                <Form className="mb-1">
                                    <Form.Group className="mb-1" controlId="respondeFormInp">
                                        <Form.Control as="textarea" rows={2} value={this.state.respuestas[ele.id]} onChange={(e) => this.onChangeRespuesta(ele.id, e.target.value)} />
                                    </Form.Group>
                                    <Form.Group className="mb-1" controlId="respondeFormBtn" className="text-right" style={{ margin: "0px" }}>
                                        <Button variant="primary" data-tip="Responder Mensaje" onClick={(e) => this.guardaComentario(ele, e)} disabled={this.state.respuestas[ele.id] ? this.state.respuestas[ele.id].trim().length == 0 : true}>
                                            <FontAwesomeIcon icon={faPaperPlane} /> Responder
                                        </Button>
                                    </Form.Group>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                )}
            </>
        )
    };

    render() {
        return (
            <Row>
                <this.muestraMensajes />
                <Modal
                    onHide={() => this.hideModalNuevoMensaje()}
                    show={this.state.modalNuevoMensaje}
                    centered
                >
                    <Modal.Header>
                        <Modal.Title>Enviar nuevo mensaje</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col xs="12" md="12" lg="12">
                                <Form.Label>
                                    Titulo:
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="tituloMensaje"
                                    className="tituloMensaje"
                                    value={this.state.tituloMensaje}
                                    onChange={this.onChangeTituloMensaje}
                                />
                            </Col>
                            <Col xs="12" md="12" lg="12">
                                <Form.Label>
                                    Mensaje:
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    type="text"
                                    name="mensajeMensaje"
                                    className="mensajeMensaje"
                                    value={this.state.mensajeMensaje}
                                    onChange={this.onChangeMensajeMensaje}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" md="12" lg="12" style={{ display: this.state.muestraSelects ? "unset" : "none" }}>
                                <Form.Label>
                                    Ambito:
                                </Form.Label>
                                <Form.Control
                                    as="select"
                                    custom
                                    type="text"
                                    name="ambito"
                                    className="mensajeAmbito"
                                    value={this.state.ambito}
                                    onChange={(e) => this.onChangeAmbito(e.target.value)}
                                >
                                    {this.state.ambitosSelect}
                                </Form.Control>
                            </Col>
                            <Col xs="12" md="12" lg="12" style={{ display: this.state.muestraSelects ? "unset" : "none" }}>
                                <Form.Label>
                                    Anexo:
                                </Form.Label>
                                <Form.Control
                                    as="select"
                                    custom
                                    type="text"
                                    name="anexo"
                                    className="mensajeAnexo"
                                    value={this.state.anexo}
                                    onChange={this.onChangeAnexo}
                                >
                                    {this.state.anexosSelect}
                                </Form.Control>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.hideModalNuevoMensaje()}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={this.ejecutar}
                            disabled={
                                this.state.tituloMensaje.trim().length == 0
                                || this.state.mensajeMensaje.trim().length == 0
                                || this.state.tituloMensaje == ""
                                || this.state.mensajeMensaje == ""
                                || (this.state.ambito == -1 && !this.props.ambito_id)
                                || (this.state.anexo == -1 && !this.props.formato)
                            }
                            onClick={() => this.enviaMensaje()}>
                            <FontAwesomeIcon icon={faPaperPlane} /> Enviar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Row>
        );
    }
}

export default withRouter(Mensajes);